import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidenavService } from '../services/sidenav.service';
import { VISIBLE_DOMAINS, DOMAINS, DOMAIN_KEYS, DOMAIN_DISPLAY_ORDER, getDefaultDomain, saveDomainPreference } from '../../../shared/constants';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { EventService } from '../services/event.service';
import * as T from '../../../shared/translations';
import { DomainKey } from '../../../shared/types/product';
import { filter, skip } from 'rxjs/operators';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [
      ReactiveFormsModule,
      RouterLink,
      MatToolbarModule,
      MatIconModule,
      MatButtonModule,
      MatSelectModule,
      MatFormFieldModule,
      KeyValuePipe,
    ]
})
export class HeaderComponent implements OnInit {
  search = '';
  domains = VISIBLE_DOMAINS;
  domainAcronyms: Record<string, string> = DOMAINS;
  domainOrder = (a: { key: string }, b: { key: string }): number =>
    DOMAIN_DISPLAY_ORDER.indexOf(a.key as any) - DOMAIN_DISPLAY_ORDER.indexOf(b.key as any);
  selectedDomain = new FormControl<DomainKey>(getDefaultDomain(), { nonNullable: true });
  T = T;
  routerUrl = '';
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private router: Router,
    readonly sidenavService: SidenavService,
    private readonly activatedRoute: ActivatedRoute,
    private eventService: EventService
  ) {}

  ngOnInit(): void {
    this.routerUrl = this.router.url;
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.routerUrl = this.router.url;
      });
    this.eventService.resetForms$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.search = '';
      });
    this.activatedRoute.queryParams
      .pipe(skip(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        const searchParam = params.search;
        if (searchParam && typeof searchParam === 'string') {
          this.search = searchParam;
        }
      });
    this.selectedDomain.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        saveDomainPreference(value);
        this.router.navigate(['/deals'], {
          queryParams: { domain: value, cat: null },
          queryParamsHandling: 'merge',
        });
        this.eventService.emitResetForms();
      });
    this.activatedRoute.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        const domain = params.domain;
        if (
          domain &&
          DOMAIN_KEYS.indexOf(domain) >= 0 &&
          this.selectedDomain.value !== domain
        ) {
          this.selectedDomain.setValue(domain, { emitEvent: false });
        }
      });
  }

  doSearch() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { search: this.search },
      queryParamsHandling: 'merge',
    });
  }
}
